import { combineReducers } from '@reduxjs/toolkit';
import localeReducer from './slices/locale';
import currentResourceReducer from './slices/currentResource';
import menusReducer from './slices/menus';
import sidebarsReducer from './slices/sidebars';
import homeReducer from './slices/home';
import authorsReducer from './slices/authors';
import articlesReducer from './slices/articles';
import categoriesReducer from './slices/categories';
import pagesReducer from './slices/pages';
import devicesReducer from './slices/devices';
import bookmarkReducer from './slices/bookmarks';
import notificationsReducer from './slices/notifications';

const rootReducer = combineReducers({
  locale: localeReducer,
  notifications: notificationsReducer,
  currentResource: currentResourceReducer,
  menus: menusReducer,
  sidebars: sidebarsReducer,
  home: homeReducer,
  authors: authorsReducer,
  articles: articlesReducer,
  categories: categoriesReducer,
  pages: pagesReducer,
  bookmarks: bookmarkReducer,
  devices: devicesReducer
});

export default rootReducer;
